// ============================================================================
//  DEMO environment - generated by 3b-build-frontends.ps1  2026-10-28 12:00
//  Base      : the repo env at 26.10.0 b2a03c516908   (07-demo-automation\repos, pinned by commit)
//  Overridden: by the values the bundle CURRENTLY SERVING demo.certacure.com uses
//              (current-configurations\live-20261028-115141\FrontEnd - HIS\main.0d9dae79ea28ce30.js)
//  from live : 34 changed, 25 identical   host moved to demo: 7   ambiguous: 0   left: 3
// ============================================================================
export const environment = {
  production: true,
  useAuthService: true,
  admission: "https://demo.certacure.com:8083/api/",
  core: "https://demo.certacure.com:8084/api/",
  lab: "https://demo.certacure.com:8085/api/",
  pharmacy: "https://demo.certacure.com:8087/api/",
  nurse: "https://demo.certacure.com:8098/api/",
  queryModel: "https://demo.certacure.com:8088/api/",
  order: "https://demo.certacure.com:8089/api/",
  authorityService: "https://demo.certacure.com:9090",
  redirectURI: "https://demo.certacure.com/callback",
  silentRedirectURI: "https://demo.certacure.com/silent",
  postLogoutRedirectURI: "https://demo.certacure.com",
  reportViewer: "https://demo.certacure.com:9092/Default.aspx",
  reportViewerWithParams: "https://demo.certacure.com:9092/ReportWithParam.aspx",
  crystalReportViewer: "https://demo.certacure.com:9002/CrystalReport.aspx",
  specimenBarcodeReportViewer: "https://demo.certacure.com:9092/LabSpecimen.aspx",
  notificationURI: "wss://demo.certacure.com:8181/connect?access_token=",
  sendNotificationURI: "https://demo.certacure.com:8181/api/Notification",
  coreImagePath: "https://demo.certacure.com:8084/imageStorage/",
  dynamicFormViewer: "https://demo.certacure.com:9095",
  dynamicFormPath: "https://demo.certacure.com:9099/api/",
  webSocketRetry: 1,
  autoRefreshSeconds: 30,
  nursingManagement: "https://demo.certacure.com:8090",
  eClaimIntegration: true,
  dimensionUrl: "https://demo.certacure.com:9081/api/",
  dimension: "https://tpo-stg.ehc.jo/api/",
  dimensionAttachement: "https://tpo-stg.ehc.jo:8000/api/",
  dimensionLicenseID: "JOR-F-000011",
  dimensionUsername: "Istishari",
  dimensionPassword: "iii.123$$$",
  dimensionDemographicInfo: "https://PRD-EHSAPI.ehc.jo/Api/v1/index.php",
  appointment: "https://demo.certacure.com:8093/api/",
  appointmentURI: "https://demo.certacure.com:8094/",
  mediSpanIntegration: true,
  mobileIntegrationEnabled: true,
  mediSpanUrl: "https://demo.certacure.com:8086/api/",
  operationManagement: "https://demo.certacure.com:6601",
  cpoeManagement: "https://demo.certacure.com:5515",
  queryBuilder: "https://demo.certacure.com:21361/api",
  sqlBuilderEngine: "https://demo.certacure.com:6602",
  worksheetTemplate: "_WorkSheet",
  notification: "https://demo.certacure.com:8282/",
  enableNotification: true,
  enableOncology: true,
  oncology: "https://demo.certacure.com:6604/api/",
  oncologyManagement: "https://demo.certacure.com:6605",
  enableAppointment: true,
  outPatientMonitorIntervalCallback: 1,
  operation: "https://demo.certacure.com:8081/api/",
  enableOperation: false,
  httpAggregatorApi: "https://demo.certacure.com:6655/api/",
  specimenLISReportURI: "http://something/orderId=",
  allowMultiReturn: false,
  cateringManagement: "https://demo.certacure.com:5555",
  discountSetup: 2, // 0 = Disable Discount, 1 = Enable Discount Approve, 2 = Discount Privilege
  labReportViewer: "https://demo.certacure.com:9092/LabSpecimen.aspx",
  validateSaudiNumber: false,
  messenger: "https://demo.certacure.com:44340",
  messengerUrl: "https://demo.certacure.com:5545",
  SecuGenUrl: 'https://localhost:8443/SGIFPCapture',
  SecuGenBody: 'Timeout=10000&Quality=20&templateFormat=ISO&licstr=',
  isSurveyMenuVisible: true,
  VatIntegrationManagement: "https://demo.certacure.com:5502",
  paciWebSocketUrl: 'ws://localhost:8080',
  homeCareUrl: "https://demo.certacure.com:5504",
  orderAndBillingImagePath: "https://demo.certacure.com:8089/imageStorage/",
  enableOutstandingBalanceAlert: false, // alert when a patient who still owes the hospital is opened/searched
};